import { connect, MapStateToProps } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { getFormItemTitle } from "../../selectors";
import { SubmenuComponent, SubmenuComponentProps } from "../SubmenuComponent";

export type SubmenuProps = {
    submenuId: number;
};

const mapStateToProps: MapStateToProps<Pick<SubmenuComponentProps, "title">, SubmenuProps, IAppState> = (state, { submenuId }) => ({
    title: getFormItemTitle(state, submenuId),
});

/**
 * Získá lokalizovaný nadpis pro submenu.
 */
export const Submenu = connect(mapStateToProps)(SubmenuComponent);
